import { TravelRiskPackageCode } from '@app/domain/model/eshop/travel/TravelRiskPackageCode';
import { GtmItemCategory } from '@app/domain/model/gtm/GtmItemCategory';

export function getRiskItemCategory(code: Nullable<string>): GtmItemCategory {
    switch (code) {
        case TravelRiskPackageCode.MedicalExpenses:
            return GtmItemCategory.TravelMedicalExpenses;
        case TravelRiskPackageCode.Accident:
            return GtmItemCategory.TravelAccident;
        case TravelRiskPackageCode.Baggage:
            return GtmItemCategory.TravelBaggage;
        case TravelRiskPackageCode.CivilResponsibility:
            return GtmItemCategory.TravelCivilResponsibility;
        default:
            return GtmItemCategory.TravelMedicalExpenses;
    }
}
